import styled from 'styled-components'
import { Button, Col, Row, Typography } from 'antd'

export { Chart } from './Chart'
export { ExportButton } from './ExportButton'
export { NoData } from './NoData'

export const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`

export const StyledButton = styled(Button)`
  background-color: transparent !important;
  & :hover {
    background-color: transparent !important;
  }
`

export const ChartsRow = styled(Row)`
  max-height: 500px;
  overflow-y: auto;
  padding-right: 15px;
`

export const HarvestedBall = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${({ theme }) => theme.colors.milestoneUpdateType.MANUAL};
  border-radius: 50%;
`

export const NextTwoWeeksHarvestedBall = styled(HarvestedBall)`
  background-color: ${({ theme }) => theme.colors.milestoneUpdateType.AUTOMATIC_CONVERSION};
`

export const LegendText = styled(Typography.Text)`
  font-size: 12px;
`

export const MarginColumn = styled(Col)`
  font-size: 12px;
  margin-bottom: 10px;
`
